export default "__VITE_ASSET__4de87946__"